<script lang="ts">
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import { onDestroy } from "svelte";

  export let mobileMode: boolean = false;

  let mobileFiltersOpen = false;
  const unsubscribe = ProductLineListingStore.subscribe(n => {
    mobileFiltersOpen = n.mobileFiltersVisible;
  });

  onDestroy(() => {
    unsubscribe();
  });
</script>

{#if mobileMode}
  <div class="fizz-has-panel" class:fizz-panel-is-open={mobileFiltersOpen}>
    <div
      class="fizz-panel"
      style="--panel-width: 100%; height: 100%; position: fixed; z-index: 20000;"
    >
      <slot />
    </div>
  </div>
{:else}
  <div data-testid="side-filter-wrapper" class="fizz-overflow-y fizz-overflow-x-hidden">
    <slot />
  </div>
{/if}
